<div class="enter-passcode d-flex flex-column container p-4">
    <div class="d-flex justify-content-start align-items-center cursor-pointer" (click)="cancel()">
        <mat-icon fontIcon="arrow_back"></mat-icon>
        <span>Back</span>
    </div>

    <div class="text-center my-4">
        <h3 class="fw-bold">Enter Passcode</h3>
        <p class="text-muted">
            Enter the 6-digit code sent to <strong>{{ maskedSenderMobile }}</strong>
        </p>
    </div>

    <div class="otp-wrapper my-4">
        <app-value-field-otp [size]="6" (OTPValue)="setPasscode($event)" (submitOTP)="submitPasscode()"></app-value-field-otp>
    </div>

    <div class="footer d-flex justify-content-start align-items-center mt-auto">
        <button
            [class.button-spinner]="loading"
            [disabled]="loading || passcode.length < 6"
            class="btn-primary rounded-pill me-2"
            mat-raised-button
            (click)="submitPasscode()"
        >
            {{ loading ? '' : 'Confirm' }}
        </button>
    </div>
</div>
